/**
* MerchandisignItemPage component
* @returns <MantencionPage />
*/
import ItemDetailMerchandising from "../components/ItemDetailMerchandising";
import Breadcrumbs from "../components/Breadcrumbs";
import Loader from "../components/Loader";

import { useGetMerchandisingItemByIdQuery } from "../redux/apiSlice";
import { useLocation, useParams } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

const MerchandisingItemPage = () => {
    // Get the location to use in the Breadcrumbs
    const location = useLocation();

    // Get the merchandising ID from the route parameters
    const { merchandisingId } = useParams();

    // Perform the query to get the merchandising item by ID
    const {
        data: merchandiseItem,
        isLoading,
        isFetching,
        isSuccess,
        isError
    } = useGetMerchandisingItemByIdQuery(merchandisingId);

    // Configure the Breadcrumbs properties
    const BreadcrumbsProps = {
        links: [
            {
                link: "/",
                label: "Inicio"
            },
            {
                link: "..",
                label: location.pathname.split("/")[1]
            },
            {
                link: `../${location.pathname.split("/")[2]}`,
                label: merchandiseItem?.title
            }
        ],

        btnConfig: {
            tag: "link",
            text: "Volver a todos el merchandising",
            color: "black",
            extraClass: "with-icon",
            hasIcon: true,
            url: "/merchandising"
        }
    }

    return (
        <>
            {isLoading && (
                <AnimatePresence>
                    <Loader />
                </AnimatePresence>
            )}
            {isSuccess && (
                <>
                    <Breadcrumbs {...BreadcrumbsProps} />
                    <ItemDetailMerchandising item={merchandiseItem} />
                </>
            )}
            {isError && <p>Hubo un error</p>}
        </>
    )
}

export default MerchandisingItemPage